import { LoaderBtn } from '../loading/Loader';
import { patternTelInput } from '@helper/functions';

export default function SendOtpForm({ modalLoginHandler, formik, loading }) {
  // const SubmitHandler =(e)=>{
  //   e.preventDefault()
  //   SetCookie("alqqi" , "slaqqvik")
  // }

  return (
    <div className="w-full max-w-[600px] h-fit bg-white z-[110] md:rounded-2xl rounded-none relative overflow-hidden">
      <div className="flex flex-col gap-12 items-center w-full relative py-12 px-2 md:px-20">
        {/* gradient */}
        {/* <span className=" flex items-center justify-center w-full h-[500px] top-24 blur-2xl opacity-70 scale-150 absolute">
          <span className="gradientLogin w-full h-full"></span>
        </span> */}
        {/* close */}
        {/* <button
          // onClick={(e) => {
          //   modalLoginHandler();
          //   formik.resetForm();
          // }}
          className="absolute p-1 flex items-center justify-center top-6 left-6 hover:bg-blackFont-100 rounded-full transition-all"
        >
          <span className="w-7 h-7 md:w-8 md:h-8 p-1">
            <img
              className="w-full h-full opacity-70"
              src="/assets/media/common/close-icon.svg"
             
            />
          </span>
        </button> */}
        {/* logo */}
        {/* <span className="w-12 h-12 md:w-16 md:h-16 p-2 flex items-center justify-center bg-primary rounded-full z-20">
          <img
            src="/assets/media/common/logo2-white.svg"
            className="w-[30px] lg:w-[50px]"
          />
        </span> */}
        {/* title */}
        <div className="flex flex-col items-center gap-8 z-10">
          <span className="text-xl md:text-2xl 2xl:text-3xl font-bold whitespace-nowrap">
            به پنل مشاورین املاک پنل خوش آمدید
          </span>
          <span className="text-sm md:text-[16px] font-[400] text-blackFont-700">
            برای ورود یا ثبت نام شماره موبایل خود را وارد کنید
          </span>
        </div>
        {/* input */}

        <div className="z-10 w-full">
          <form onSubmit={formik.handleSubmit} className="flex flex-col gap-10 w-full">
            <div className="relative">
              <label
                className={`w-full rounded-lg border-[1.5px] ${
                  formik.errors.phone && formik.touched.phone
                    ? 'border-error'
                    : 'border-blackFont-300 has-[:focus]:border-blackFont-900'
                } px-2 h-[48px] flex items-center justify-between z-10 overflow-hidden transition-all`}
              >
                <input
                  name="phone"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                  dir="ltr"
                  style={{ direction: 'ltr' }}
                  className="flex-1 h-full py-3 bg-transparent text-base px-2 placeholder:text-blackFont-300"
                  placeholder="شماره موبایل"
                  type="tel"
                  onInput={patternTelInput}
                />
                <span className="bg-blackFont-300 h-[25px] w-[1px] flex"></span>
                <span className="w-fit px-2 text-blackFont-400">98+</span>
              </label>
              <span
                className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
                  formik.errors.phone && formik.touched.phone ? 'visible opacity-100' : 'invisible opacity-0'
                }`}
              >
                {formik.errors.phone}
              </span>
            </div>
            <div className="flex flex-col w-full gap-3 z-10">
              <div className="text-[12px] text-blackFont-400 flex items-start gap-1">
                <img className="w-[18px] opacity-70" src="/svg/attention.svg" alt="attention" />
                <span>استفاده از پنل به معنی پذیرش قوانین و مقررات این سرویس است.</span>
              </div>

              <button
                type="submit"
                disabled={formik.errors.phone || !formik.values.phone || loading}
                className="bg-primary disabled:cursor-not-allowed disabled:bg-blackFont-300 w-full h-[48px] flex items-center justify-center text-white rounded-lg transition-all"
              >
                {loading ? <LoaderBtn /> : 'تایید و دریافت کد'}
              </button>
            </div>
          </form>
        </div>

        {/*  */}
      </div>
    </div>
  );
}
